module.exports = require("./lib/_stream_passthrough.js")



/*****************
 ** WEBPACK FOOTER
 ** ../~/stream-browserify/~/readable-stream/passthrough.js
 ** module id = 1011
 ** module chunks = 1
 **/


/*****************
 ** WEBPACK FOOTER
 ** ../~/stream-browserify/~/readable-stream/passthrough.js
 ** module id = 1011
 ** module chunks = 1
 **/